import { NotificationManager } from 'react-notifications';
import {
  createRouteCategoryRequest,
  deleteRouteCategoryRequest,
  getIssuerRouteCategoryRequest,
  getRouteCategoryRequest,
  toggleRouteCategoryRequest,
  updateRouteCategoryRequest
} from 'src/api/RouteCategoryRequest';
import { requestWrapper } from 'src/utils/utils';
import { checkRequestError } from '.';
import { GET_ROUTE_CATEGORIES } from '../types';

export const getRouteCategoryAction = (filterObj, profile) => async (
  dispatch
) => {
  try {
    const { data } =
      profile.super == 1
        ? await getRouteCategoryRequest(filterObj)
        : await getIssuerRouteCategoryRequest(filterObj);
    checkRequestError(data);

    dispatch({
      type: GET_ROUTE_CATEGORIES,
      payload: data.content.data?.all || [] // if empty, data returns null. hence send []
    });
    return { message: data.success.message, status: 1 };
  } catch (error) {
    // NotificationManager.info(error.message, 'Error');
    return { message: error.message, status: 0 };
  }
};

export const createRouteCategoryAction = (payload, profile) => async (
  dispatch
) => {
  try {
    const { data } = await createRouteCategoryRequest(requestWrapper(payload));
    checkRequestError(data);

    dispatch(getRouteCategoryAction({}, profile));
    NotificationManager.success(data.success.message, 'Success');
    return { message: data.success.message, status: 1 };
  } catch (error) {
    NotificationManager.info(error.message, 'Information');
    return { message: error.message, status: 0 };
  }
};

export const updateRouteCategoryAction = (id, payload, profile) => async (
  dispatch
) => {
  try {
    const { data } = await updateRouteCategoryRequest(
      id,
      requestWrapper(payload)
    );
    checkRequestError(data);

    dispatch(getRouteCategoryAction({}, profile));
    NotificationManager.success(data.success.message, 'Success');
    return { message: data.success.message, status: 1 };
  } catch (error) {
    NotificationManager.info(error.message, 'Information');
    return { message: error.message, status: 0 };
  }
};

export const toggleRouteCategoryAction = (id, payload, profile) => async (
  dispatch
) => {
  try {
    const { data } = await toggleRouteCategoryRequest(
      id,
      requestWrapper(payload)
    );
    checkRequestError(data);

    dispatch(getRouteCategoryAction({}, profile));
    NotificationManager.success(data.success.message, 'Success');
    return { message: data.success.message, status: 1 };
  } catch (error) {
    NotificationManager.info(error.message, 'Information');
    return { message: error.message, status: 0 };
  }
};

export const deleteRouteCategoryAction = (id, profile) => async (dispatch) => {
  try {
    const { data } = await deleteRouteCategoryRequest(id);
    checkRequestError(data);

    dispatch(getRouteCategoryAction({}, profile));
    NotificationManager.success(data.success.message, 'Success');
    return { message: data.success.message, status: 1 };
  } catch (error) {
    NotificationManager.info(error.message, 'Information');
    return { message: error.message, status: 0 };
  }
};
